import { render, staticRenderFns } from "./NavigationTabsSecondaryTab.vue?vue&type=template&id=630dd730&scoped=true"
import script from "./NavigationTabsSecondaryTab.vue?vue&type=script&lang=js"
export * from "./NavigationTabsSecondaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630dd730",
  null
  
)

export default component.exports